import { createSlice } from "@reduxjs/toolkit"
import { fetchBlog } from "../blog/slice";
import { holderFeature } from "../holder";
import adapter from "./adapter"

const NAME = 'blogForm'

// const initialForm = {
//   title_en: '',
//   title_id: '',
//   content_en: '',
//   content_id: '',
//   categories: [],
//   visibility: 'public',
//   suitable: [],
//   tags: [],
//   image: undefined
// }

const initialData = {}

const initialState = {
  _payload: null,
  status: "idle",
  error: "",
  data: initialData,

  ...holderFeature.generateInitialState()
};

export const blogSlice = createSlice({
  name: NAME,
  initialState,
  reducers: {
    setStatus(state, action){
      state.status = action.payload
    },
    updateForm(state, action){
      state.data[action.payload.key] = action.payload.value
    },
    reset(state){
      state.data = initialData
    },

    ...holderFeature.generateReducer()
  },
  extraReducers: {
    [fetchBlog.pending]: (state) => {
      state.status = "loading";
    },
    [fetchBlog.fulfilled]: (state, action) => {
      state.status = "succeeded";
      state._payload = action.payload;
      const blog = action.payload.results;
      state.data = adapter.responseBodyToForm(blog);
    },
    [fetchBlog.rejected]: (state, action) => {
      state.status = "failed";
      state.error = action.error.message;
    },
  }
});

export const {
  setStatus,
  updateForm,
  reset,
  addToHolder,
  emptyHolder
} = blogSlice.actions

export default blogSlice.reducer;
